<template>

	<vue-draggable-resizable :drag-cancel="'.edit_con'" ref="moveDraggabel" :x="itemMdata.parentStyle.left" :draggable="isDraggable" :y="itemMdata.parentStyle.top" :z="itemMdata.parentStyle.zIndex" :minw="1" :minh="1" :w="itemMdata.parentStyle.width" :h="itemMdata.parentStyle.height" :active.sync="itemMdata.parentStyle.active" v-on:dragging="onDrag" :parent="itemMdata.parent" v-on:resizing="onResize" v-on:activated="activated" v-on:dragstop="onDragstop">
		<div :id="itemMdata.allId" :class="['hove_con',itemMdata.emitStr,itemMdata.tName,{hover:itemMdata.parentStyle.active,fixed:itemMdata.styleShow==2||itemMdata.styleShow==3||itemMdata.styleShow==4}]" :style="{width:itemMdata.fullScreen?'100%':itemMdata.parentStyle.width+'px',height:itemMdata.parentStyle.height+'px'}" @contextmenu="showMenu">
			<p class="edit_con" style="z-index:100;" v-if="isMtemplates" @click.stop >
				<span class="" v-if="itemMdata.tName=='mFont'" @click.stop="manageMfont(itemMdata)">编辑文本</span>
				<span class="icon edit_mode" @click.stop="manageMode(itemMdata)"><i>管理{{itemMdata.tText}}</i></span>
				<span class="icon animation" @click.stop="funcEmition(itemMdata)"><i>设置动画</i></span>
				<span class="icon style" v-if="itemMdata.tName=='moduleAreaNav'" @click="editDial.isStyleEdit = true"><i>设置样式</i></span>
				<span class="icon style" v-if="itemMdata.tName=='msgSubmit'||itemMdata.tName=='siteForm'||itemMdata.tName=='signUp'||itemMdata.tName=='memberPassword'||itemMdata.tName=='memberLogin'" @click="editDial.isStyleEdit = true"><i>编辑按钮</i></span>
				<!--span class="icon edit_Code" @click="managecode(itemMdata)"><i>编辑代码</i></span>
				<span class="icon borderhid"><i>禁止编辑</i></span-->
				<span @click="removeComponent(itemMdata)" class="icon delete"><i>删除模块</i></span>
			</p>
			<div :itemMdata="itemMdata" ref="child" @isFuncur="isFuncur"  :is="itemMdata.tName"></div>
			<moduleAreaNavStyle v-if="editDial.isStyleEdit" :itemMdata='itemMdata' :editDial="editDial"></moduleAreaNavStyle>
		</div>
		<vue-context-menu :contextMenuData="contextMenuData" @upFloor="upFloor(itemMdata)" @moveUpFloor="moveUpFloor(itemMdata)" @moveDownFloor="moveDownFloor(itemMdata)" @downFloor="downFloor(itemMdata)" @copyItem="copyItem(itemMdata)">
		</vue-context-menu>
	</vue-draggable-resizable>

</template>
<script>
	let ov = {};
	import VueDraggableResizable from 'vue-draggable-resizable'
	import moduleAreaNavStyle from './m/moduleAreaNavStyle.vue'
	import bus from '@/common/bus.js'
	import api from '@/api/$ajax.js'
	ov['VueDraggableResizable'] = VueDraggableResizable;
	ov['moduleAreaNavStyle'] = moduleAreaNavStyle;
	let mName = ['mFont', 'mImage', 'mButton', 'signUp', 'memberPassword', 'graphic', 'mNewDes', 'columnPicture', 'mCaseDes', 'mPhotoDes', 'multiCarousel', 'circleRrea', 'areaVideo', 'articleScrap', 'productNav', 'newlyShop', 'productShow', 'productDes', 'productSearch', 'photoMoreCard', 'areaFile', 'areaMap', 'areaIndexFavorite', 'areaLocation', 'videoNav', 'areaMap', 'sidebar', 'moduleAreaNav', 'footerNav', 'memberLogin', 'msgSubmit', 'siteForm', 'serviceOnline', 'siteQrCode', 'zhaopin', 'photoMoreCard', 'zhaopinDetail', 'areaFileNav', 'mltilingual', 'areaCode', 'sitemap', 'singlePage', 'areaDate', 'areaFlv', 'friendLink', 'searchResults'];

	for(let m = 0; mName.length > m; m++) {
		ov[mName[m]] = () =>
			import('./m/' + mName[m] + '.vue');
	}

	export default {
		name: 'mConet',
		props: ['itemMdata', "itemInner"],
		components: ov,
		created() {
			let ts = this;

			ts.itemMdata.allId = ts.itemMdata.allId || "m" + ts.$utils.GenNonDuplicateID();
			ts.itemMdata.parentStyle.zIndex = ts.itemMdata.parentStyle.zIndex < 0 ? 0 : ts.itemMdata.parentStyle.zIndex;
			ts.itemMdata.parentStyle.width = ts.itemMdata.parentStyle.width || 1;
			ts.itemMdata.parentStyle.height = ts.itemMdata.parentStyle.height || 1;

			bus.$on('isfontFocus' + ts.itemMdata.allId, (data) => {
				ts.isDraggable = data;
			});

			ts.itemMdata.isStyleEdit = false;
			ts.itemMdata.emitStr = ts.itemMdata.emitStr || "";
		},
		methods: {
			manageMode(i) { //弹窗模块编辑
				let ts = this;
				ts.$refs.child.isFuncur(ts.itemMdata, 1);
			},
			isFuncur(i, editDial, flag) { //激活弹窗模块编辑

				let ts = this;
				if(flag == 2) {
					ts.editCodeFun(i, editDial);
				} else {
					editDial.content = "";
					ts.$emit('isFuncur', i, editDial);
				}

			},
			manageMfont() { //编辑文本模块
				this.$refs.child.editorFun();
			},
			funcEmition(item) { //设置模块动画
				console.log(item);
				bus.$emit('onSetAmit', item);
			},
			managecode(i) { //管理模块代码
				let ts = this;
				ts.$refs.child.isFuncur(ts.itemMdata, 2);
			},
			editCodeFun(i, editDial) { //编辑代码后的回调
				let ts = this;
				let obj = {
					tName: i.tName,
					type: ts.param.type
				};
				if(i.editorId) {
					obj = {
						id: i.editorId
					};
				}
				api.get('https://bjq.aititiapi.top/api/modular/des', false, obj, function(data) {
					// console.log(Base64.decode(data.data.content));
					editDial.isEdit = true;
					editDial.content = Base64.decode(data.data.content);
					ts.$emit('isFuncur', i, editDial);
				});
			},
			removeComponent(i) {  //删除模块
				let ts = this;
				ts.$emit('removeComponent', i);
				ts.$emit('recomponent', i);
			},
			onDrag: function(x, y) {

       this.isMtemplates=false;
       $("#guide-th").show()
       $("#guide-lv").show()
       $("#guide-mh").show()
       $("#guide-mv").show()
       var offset=$(this.$refs.moveDraggabel.$el).offset();
       var Html = $("html");
       var target=$(this.$refs.moveDraggabel.$el);
          //顶水平线
          $("#guide-th").css({
            "top":offset.top,
            "left":0

          })
             //左垂直线
             $("#guide-lv").css({
               "left":offset.left,
               "top":0,
               "height":Html.height()
             })
             //底水平线
             $("#guide-bh").css({
               "top":offset.top+target.outerHeight(),
               "left":0
             })
             //右垂直线
             $("#guide-rv").css({
               "left":offset.left+target.outerWidth(),
               "top":0,
               "height":Html.height()
             })
             //中水平线
             $("#guide-mh").css({
               "top":offset.top+target.outerHeight()/2,
               "left":0
             })
             //中垂直线
             $("#guide-mv").css({
               "left":offset.left+target.outerWidth()/2,
               "top":0,
               "height":Html.height()
             })
       // $(this.$refs.moveDraggabel).parents(".columnLayoutInner").unbind('mousemove')

       $(this.$refs.moveDraggabel.$el).siblings('.draggable').css({
         "border":"1px solid #ff0097"
       })
				let ts = this;

				ts.itemMdata.parentStyle.left = x;
				ts.itemMdata.parentStyle.top = y;
			},
			activated: function(x, y, width, height) {
				 let ts = this;

			},
			onResize: function(x, y, width, height) {
				let ts = this;
				let itemMdata = ts.itemMdata;

				itemMdata.parentStyle.left = x;
				itemMdata.parentStyle.top = y;


				if(width>1){
					itemMdata.parentStyle.width = width;
				}

				if(height>1){
					itemMdata.parentStyle.height = height;
				}
				if(ts.$refs.child && ts.$refs.child.resizefun) {
					ts.$refs.child.resizefun(width + 'px', height + 'px');
				}
			},
			onDragstop() {
         this.isMtemplates=true;
        $("#guide-th").hide()
        $("#guide-lv").hide()
        $("#guide-mh").hide()
        $("#guide-mv").hide()
       $(this.$refs.moveDraggabel.$el).siblings('.draggable').css({
          "border":"none"
        })

				console.log("onDragstop");
			},
			moveDownFloor(i) {
				if(i.parentStyle.zIndex > 0) {
					--i.parentStyle.zIndex;
				}
			},
			copyItem(item) {
				let ts = this;
				var i = JSON.parse(JSON.stringify(item));
				i.parentStyle.left = item.parentStyle.left + 20;
				i.parentStyle.top = item.parentStyle.top + 20;
				i.allId = "m" + ts.$utils.GenNonDuplicateID();
				i.parentStyle.zIndex = ts.itemInner.length + 1;
				ts.itemInner.push(i);
			},
			downFloor(i) {
				i.parentStyle.zIndex = 0;
			},
			upFloor(i) {
				i.parentStyle.zIndex += this.itemInner.length;
			},
			moveUpFloor(i) { //模块
				++i.parentStyle.zIndex;
			},
			showMenu(index) { //右键弹窗显示
				event.preventDefault();
				event.stopPropagation();
				var x = event.clientX;
				var y = event.clientY;
				this.contextMenuData.axios = {
					x,
					y
				}
			}
		},
		mounted() {
			let ts = this;
			if(ts.itemMdata.emitStr) {
				setTimeout(function() {
					hoverAction.initScroll(ts.itemMdata.allId, ts.itemMdata.emitStr);
				}, 400);
			}
		},
		data() {
			return {
				title: "模块容器",
				editDial: {
					editDialWidth: "700px",
					editDialHeight: "580px",
					isEdit: true,
					isStyleEdit: false,
					title: '管理' + this.itemMdata.tText,
				},
				isDraggable: true,
				param: {
					id: this.$route.params.id,
					param: this.$route.params.param,
					company_id: this.$route.query.company_id,
					token: this.$route.query.token,
					type: this.$route.query.type,
					lang: this.$route.query.lang,
					domain_url: this.$route.query.domain_url,
					mobile_version_id: this.$route.query.mobile_version_id,
					pc_version_id: this.$route.query.pc_version_id
				},
				contextMenuData: {
					// the contextmenu name(@1.4.1 updated)
					menuName: this.$utils.guid(),
					axios: {
						x: null,
						y: null
					},
					//Menu options (菜单选项)
					menulists: [{
							fnHandler: 'upFloor', // Binding events(绑定事件)
							btnName: '置于顶层' // The name of the menu option (菜单名称)
						},
						{
							fnHandler: 'moveUpFloor',
							btnName: '上移一层'
						},
						{
							fnHandler: 'moveDownFloor',
							btnName: '下移一层'
						},
						{
							fnHandler: 'copyItem',
							btnName: '复制模块'
						},
						{
							fnHandler: 'downFloor',
							btnName: '置于底层'
						}
					]
				},
        isMtemplates:true

			}
		}
	}
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
	.pc_con .hove {}
</style>



// WEBPACK FOOTER //
// src/components/t1/mConet.vue